import { ReturnDetails } from "@App/Pages/VehicleReturn/ReturnDetails";
import { ReturnIdentity } from "@App/Pages/VehicleReturn/ReturnIdentity";
import { ReturnSubmit } from "@App/Pages/VehicleReturn/ReturnSubmit";
import { ReturnSummary } from "@App/Pages/VehicleReturn/ReturnSummary";
import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";
import type { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

export const VehicleReturn: FunctionComponent = () => {
  const { navigateWithQuery } = useNavigateWithQueryParams();

  return (
    <Routes>
      <Route
        path={"/"}
        element={<ReturnIdentity onSubmit={() => navigateWithQuery("details")} />}
      />
      <Route
        path={"/details"}
        element={<ReturnDetails onSubmit={() => navigateWithQuery("../zusammenfassung", true)} />}
      />
      <Route
        path={"/zusammenfassung"}
        element={<ReturnSubmit onSubmit={() => navigateWithQuery("../danke", true)} />}
      />
      <Route path={"/danke"} element={<ReturnSummary />} />
    </Routes>
  );
};
